import { useEffect } from 'react'

/**
 * Hook to save scroll position in sessionStorage
 * The storageKey should be a namespaced key to avoid collisions with other components.
 * @param storageKey - The key to use in sessionStorage - e.g: 'unlock:max:app:{appId}:sidePanel:dealNotes:scroll'
 * @example useScrollPosMemory('unlock:max:app:{appId}:sidePanel:dealNotes:scroll')
 */
export function useScrollPosMemory(storageKey: string) {
  useEffect(() => {
    const mountElement = document.getElementById('sidePanelScrollView')
    const scrollPos = sessionStorage.getItem(storageKey)
    if (scrollPos) {
      mountElement.scrollTop = JSON.parse(scrollPos)
    }
    const handleScroll = () => {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          x: mountElement.scrollLeft,
          y: mountElement.scrollTop,
        })
      )
    }
    mountElement.addEventListener('scrollend', handleScroll)

    // Restore scroll position from sessionStorage
    try {
      const scrollPosition = JSON.parse(sessionStorage.getItem(storageKey) || '{}')
      if (scrollPosition) {
        mountElement.scrollTo({ top: scrollPosition.y, left: scrollPosition.x })
      }
    } catch (error) {
      console.error('Failed to parse scroll position from sessionStorage', error)
    }

    return () => {
      mountElement.removeEventListener('scrollend', handleScroll)
    }
  }, [storageKey])
}
